import { render, staticRenderFns } from "./CampoFicheroDataURL.vue?vue&type=template&id=1a425e74&"
import script from "./CampoFicheroDataURL.vue?vue&type=script&lang=js&"
export * from "./CampoFicheroDataURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
